import { TextureLoader } from "excalibur";
import { playerState } from "../state/stateManager";
import { Resources } from "../Resources";
import colinPortrait from "./../../res/colinPortrait.png";
import charPortrait from "./../../res/charPortrait.png";
import aliviaPortrait from "./../../res/AliviaPortrait.png";
import cowboyPortrait from "./../../res/cowboyPortrait.png";
import grandpaPortrait from "./../../res/grandpaPortrait.png";
import hippyChickPortrait from "./../../res/hippyChickPortrait.png";
import kaisonPortrait from "./../../res/kaisonPortrait.png";
import katiePortrait from "./../../res/katiePortrait.png";
import kennedyPortrait from "./../../res/kennedyPortrait.png";
import margiePortrait from "./../../res/margiePortrait.png";
import professorPortrait from "./../../res/professorPortrait.png";
import sparkyPortrait from "./../../res/sparkyPortrait.png";
import ronaldPortrait from "./../../res/ronaldPortrait.png";
import lindaPortrait from "./../../res/lindaPortrait.png";
import bigBenPortrait from "./../../res/bigBenPortrait.png";
import marvinPortrait from "./../../res/marvinPortrait.png";
import billPortrait from "./../../res/farleyPortrait.png";
import kevinPortrait from "./../../res/kevinPortrait.png";
import jacksonPortrait from "./../../res/jacksonPortrait.png";
export default class QuestionDialog {
  constructor(content, replies, endCallback, user, yOffset) {
    console.log("inside dialog: user is: ", user);
    this.gameContent = playerState.getContent();
    this.replies = replies;
    this.content = content;
    this.clicking = false;
    this.dialogContainer = document.getElementById("dialog");
    // if (yOffset == undefined || yOffset !== "top") {
    //   this.dialogContainer.style.bottom = 0;
    //   this.dialogContainer.style.top = "unset";
    // } else {
    //   this.dialogContainer.style.top = 0;
    //   this.dialogContainer.style.bottom = "unset";
    // }
    Resources.Footsteps.stop();
    this.dialogContainer.style.display = "flex";
    this.finished = false;
    this.index = 0;
    this.lines = 0;
    this.selectedReply = 0;
    this.pauseCount = 15;
    this.chars = this.content[0].length;
    this.text = ["", "", "", ""];
    this.portrait = document.getElementById("portrait");
    this.textBox0 = document.getElementById("textBox0");
    this.textBox1 = document.getElementById("textBox1");
    this.textBox2 = document.getElementById("textBox2");
    this.textBox3 = document.getElementById("textBox3");
    this.textBox0.innerHTML = ``;
    this.textBox1.innerHTML = ``;
    this.textBox2.innerHTML = ``;
    this.textBox3.innerHTML = ``;
    if (user == "player") {
      this.portrait.innerHTML = `<img src="${charPortrait}"/>`;
    } else if (user == "grandpa") {
      this.portrait.innerHTML = `<img src="${grandpaPortrait}"/><h1>Grandpa</h1>`;
    } else if (user == "margie") {
      this.portrait.innerHTML = `<img src="${margiePortrait}"/><h1>Margie</h1>`;
    } else if (user == "roger") {
      this.portrait.innerHTML = `<img src="${cowboyPortrait}"/><h1>Roger</h1>`;
    } else if (user == "katie") {
      this.portrait.innerHTML = `<img src="${katiePortrait}"/><h1>Katie</h1>`;
    } else if (user == "colin") {
      this.portrait.innerHTML = `<img src="${colinPortrait}"/><h1>Colin</h1>`;
    } else if (user == "kennedy") {
      this.portrait.innerHTML = `<img src="${kennedyPortrait}"/><h1>Kennedy</h1>`;
    } else if (user == "hippyChick") {
      this.portrait.innerHTML = `<img src="${hippyChickPortrait}"/><h1>Hippy</h1>`;
    } else if (user == "alivia") {
      this.portrait.innerHTML = `<img src="${aliviaPortrait}"/><h1>Alivia</h1>`;
    } else if (user == "sparky") {
      this.portrait.innerHTML = `<img src="${sparkyPortrait}"/><h1>Sparky</h1>`;
    } else if (user == "professor") {
      this.portrait.innerHTML = `<img src="${professorPortrait}"/><h1>Prof</h1>`;
    } else if (user == "kaison") {
      this.portrait.innerHTML = `<img src="${kaisonPortrait}"/><h1>Kaison</h1>`;
    } else if (user == "ronald") {
      this.portrait.innerHTML = `<img src="${ronaldPortrait}"/><h1>Ronald</h1>`;
    } else if (user == "linda") {
      this.portrait.innerHTML = `<img src="${lindaPortrait}"/><h1>Linda</h1>`;
    } else if (user == "bigBen") {
      this.portrait.innerHTML = `<img src="${bigBenPortrait}"/><h1>Big Ben</h1>`;
    } else if (user == "marvin") {
      this.portrait.innerHTML = `<img src="${marvinPortrait}"/><h1>Marvin</h1>`;
    } else if (user == "bill") {
      this.portrait.innerHTML = `<img src="${billPortrait}"/><h1>Bill</h1>`;
    } else if (user == "kevin") {
      this.portrait.innerHTML = `<img src="${kevinPortrait}"/><h1>Kevin</h1>`;
    } else if (user == "jackson") {
      this.portrait.innerHTML = `<img src="${jacksonPortrait}"/><h1>Jackson</h1>`;
    }
    this.finish = () => {
      endCallback(this.replies[this.selectedReply], this.selectedReply);
    };
    this.startTyping();
  }

  startTyping() {
    console.log("question: replies", this.replies);

    this.typing = setInterval(() => {
      if (!this.finished) {
        if (this.pauseCount < 20) {
          this.pauseCount++;
        } else if (this.pauseCount == 20) {
          this.pauseCount++;
        } else if (this.pauseCount > 20) {
          if (this.index !== this.content[this.lines].length) {
            this.text[this.lines] =
              this.text[this.lines] +
              this.content[this.lines].charAt(this.index);
            Resources.Keypress.play(0.1);

            this.index++;
          } else {
            this.lines++;
            this.index = 0;
            this.pauseCount = 0;

            if (this.lines == this.content.length) {
              console.log(
                "dialog setting this.finished, replies length: ",
                this.replies
              );
              this.finished = true;
              // if (this.replies.length == 1) {
              //   this.textBox1.innerHTML = `<p class="reply">${
              //     this.selectedReply == 0 ? ">" : ""
              //   } ${this.replies[0]}</p>`;
              // }
              // if (this.replies.length == 2) {
              //   this.textBox2.innerHTML = `<p class="reply">${
              //     this.selectedReply == 1 ? ">" : ""
              //   } ${this.replies[1]}</p>`;
              // } else {
              //   this.textBox2.innerHTML = ``;
              //   this.textBox3.innerHTML = ``;
              // }
              // if (this.replies.length >= 2) {
              //   this.textBox3.innerHTML = `<p class="reply">${
              //     this.selectedReply == 2 ? ">" : ""
              //   } ${this.replies[2]}</p>`;
              // }
              this.setRepliesToUI();
            }
          }

          this.textBox0.innerHTML = `${this.text[0]}`;
        }
      }
    }, 70);
  }
  iterateReply(direction) {
    Resources.Click.play();
    console.log(
      "reply: direction",
      direction,
      " selected: ",
      this.selectedReply,
      " length: ",
      this.replies.length
    );
    if (!direction) {
      console.log("should iterate reply up");
      if (this.selectedReply === this.replies.length - 1) {
        console.log("reply at max, setting to zero");
        this.selectedReply = 0;
      } else {
        console.log("iterating reply up");
        this.selectedReply++;
      }
    } else {
      console.log("should iterate reply down");
      if (this.selectedReply === 0) {
        console.log("reply at zero, setting to length");
        this.selectedReply = this.replies.length - 1;
      } else {
        console.log("reply not zero, deducting one");
        this.selectedReply = this.selectedReply - 1;
      }
    }
    this.setRepliesToUI();
  }

  enterPress() {
    console.log("inside enterpress dialog");
    if (this.finished) {
      this.destroy();
      this.finish();
    } else {
      this.finished = true;
      this.setRepliesToUI();
      clearInterval(this.typing);
    }
  }
  setRepliesToUI() {
    console.log("setting replies: ", this.replies.length);
    this.textBox0.innerHTML = `${this.content[0]}`;
    if (this.replies == 1) {
      this.textBox1.innerHTML = `<p class="reply">${
        this.selectedReply == 0 ? ">" : ""
      } ${this.replies[0]}</p>`;
    }

    if (this.replies.length == 2) {
      this.textBox1.innerHTML = `<p class="reply">${
        this.selectedReply == 0 ? ">" : ""
      } ${this.replies[0]}</p>`;
      this.textBox2.innerHTML = `<p class="reply">${
        this.selectedReply == 1 ? ">" : ""
      } ${this.replies[1]}</p>`;
    }
    if (this.replies.length == 3) {
      this.textBox1.innerHTML = `<p class="reply">${
        this.selectedReply == 0 ? ">" : ""
      } ${this.replies[0]}</p>`;
      this.textBox2.innerHTML = `<p class="reply">${
        this.selectedReply == 1 ? ">" : ""
      } ${this.replies[1]}</p>`;
      this.textBox3.innerHTML = `<p class="reply">${
        this.selectedReply == 2 ? ">" : ""
      } ${this.replies[2]}</p>`;
    }
  }
  destroy() {
    clearInterval(this.typing);
    this.dialogContainer.style.display = "none";
    this.textBox0.innerHTML = ``;
    this.textBox1.innerHTML = ``;
    this.textBox2.innerHTML = ``;
    this.textBox3.innerHTML = ``;
    this.replies = [];
  }
}
